import service from './request'
import uploadService from "./uploadRequest.js"

/**
 * 所有工单
 */
 export const orderGetAllRec = data => {
  return service({
      showLoading: true,
      url: '/crm/order/getAllRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单添加
 */
 export const orderAddInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单修改
 */
 export const orderUpdateInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单附件上传
 */
 export const orderUploadFile = data => {
  return uploadService({
      showLoading: true,
      url: '/crm/order/uploadFile',
      method: 'post',
      data
  })
}

/**
 * 保存附件列表
 */
 export const saveAttList = data => {
  return service({
      showLoading: false,
      url: '/crm/order/saveAttList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取附件列表
 */
 export const getAttList = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getAttList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单跟进
 */
 export const orderAddFollowInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/addFollowInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单分配
 */
 export const orderSetOper = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/setOper',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单接单
 */
 export const orderReceiveOrder = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/receiveOrder',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单解决
 */
 export const orderSetSolved = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/setSolved',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单关闭
 */
 export const orderClose = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/close',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单延期申请
 */
 export const orderExtensionApply = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/extensionApply',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单撤回
 */
 export const orderRecall = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/recall',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单催单
 */
 export const orderReminder = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/reminder',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单驳回
 */
 export const orderReject = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/reject',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 我的未解决工单
 */
 export const orderUnResolvedRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/my/unResolvedRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 我的已解决工单
 */
 export const orderResolvedRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/my/resolvedRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 我参与的工单
 */
 export const orderMyAll = data => {
  return service({
      showLoading: false,
      url: '/crm/order/my/all',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 组内未解决工单
 */
 export const orderGroupUnResolvedRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/group/unResolvedRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 组内已解决工单
 */
 export const orderGroupResolvedRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/group/resolvedRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 督办工单
 */
 export const orderGetSuperviseRec = data => {
  return service({
      showLoading: true,
      url: '/crm/order/getSuperviseRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单电话回访
 */
 export const orderGetTelVisitRec = data => {
  return service({
      showLoading: true,
      url: '/crm/order/getTelVisitRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单同一客户历史工单信息
 */
 export const orderGetOtherOrderList = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getOtherOrderList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单详情
 */
 export const orderGetInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单跟进记录
 */
 export const orderGetFollowList = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getFollowList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单催单记录
 */
 export const orderGetReminderList = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getReminderList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单延期处理记录
 */
 export const orderGetExtensionRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getExtensionRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单回访及满意度调查记录
 */
 export const orderGetVisitSatisfactionRec = data => {
  return service({
      showLoading: false,
      url: '/crm/order/getVisitSatisfactionRec',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 获取工单评价信息
 */
 export const getSatInfo = data => {
  return service({
      showLoading: false,
      url: '/crm/order/extApi/sat/getInfo',
      method: 'post',
      type: 'body',
      newVdnId: true, //外部应用接口增加配置项
      data
  })
}

/**
 * 工单评价信息提交
 */
 export const saveSatData = data => {
  return service({
      showLoading: false,
      url: '/crm/order/extApi/sat/saveData',
      method: 'post',
      type: 'body',
      newVdnId: true, //外部应用接口增加配置项
      data
  })
}

/**
 * 获取工单处理按钮
 */
 export const getButton = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/getButton',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单延期申请取消
 */
 export const extensionApplyCancel = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/extensionApplyCancel',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 工单打回
 */
 export const rollback = data => {
  return service({
      showLoading: false,
      url: '/crm/order/handle/rollback',
      method: 'post',
      type: 'body',
      data
  })
}



// WEBPACK FOOTER //
// ./src/http/orderManagement.js